// extracted by mini-css-extract-plugin
module.exports = {"list":"PanelContent_list__2EhYC","header":"PanelContent_header__fmlLL","result":"PanelContent_result__oVwsz","deleteBtn":"PanelContent_deleteBtn__3zaM7"};